export const techStack = [
  "React",
  "Redux",
  "NodeJS",
  "Express",
  "MongoDB",
  "SQL",
  "Javascript",
  "Python",
  "GitHub",
  "REST API",
  "HTML",
  "CSS",
  "MaterialUI",
  "Tailwind CSS",
];
